import { render, staticRenderFns } from "./ip-range.vue?vue&type=template&id=4aed6f5e"
import script from "./ip-range.vue?vue&type=script&lang=js"
export * from "./ip-range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports